import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Paragraph,
  Checkbox,
  Flex,
  Button,
  rem,
} from '@vimeo/bokeh';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';

import { IModalProps } from './useModalProps';
import { T_CANCEL, T_CONFIRM, T_DONT_ASK_ME_AGAIN_TO_DELETE } from '../../../../translations';
import { CallablePlaceholder } from '../../../../types/general';
import { createDomName } from '../../../../utils/dom/identifying';

export function ChatHistoryModal({
  className = createDomName('chat-modal'),
  active,
  header,
  text,
  cancelAction,
  confirmAction,
  showAskAgainCheckBox = false,
  onCheck = CallablePlaceholder,
}: IBaseDomElementProps & IModalProps) {
  return (
    <Modal size={'sm'} isOpen={active} onClose={CallablePlaceholder}>
      <ModalOverlay />

      <ModalContent className={createDomName(className, 'content')}>
        <ModalHeader className={createDomName(className, 'header')}>{header}</ModalHeader>

        <ModalBody>
          <Paragraph className={createDomName(className, 'text')} size={'md'} display={'block'}>
            {text}
          </Paragraph>
        </ModalBody>

        <ModalFooter flexDirection={'column'}>
          {showAskAgainCheckBox ? (
            <Checkbox
              className={createDomName(className, 'checkbox')}
              width={'100%'}
              color={'text-primary'}
              autoFocus={false}
              onChange={onCheck}
            >
              {T_DONT_ASK_ME_AGAIN_TO_DELETE}
            </Checkbox>
          ) : null}

          <Flex gap={rem(16)} width={'100%'}>
            <Button
              className={createDomName(className, 'cancel-button')}
              variant={'secondary'}
              width={'100%'}
              onClick={cancelAction}
            >
              {T_CANCEL}
            </Button>

            <Button
              className={createDomName(className, 'confirm-button')}
              variant={'destructive'}
              width={'100%'}
              onClick={confirmAction}
            >
              {T_CONFIRM}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
